import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { type SexClass } from "@/benchmarks/BenchmarkFilters/SexPicker";
import { Benchmarks } from "@/benchmarks/Benchmarks";
import { ErrorComponent } from "@/components/Error";

export const filterSchema = z.object({
  sexClass: z
    .array(z.enum(["STEER", "HEIFER", "MIXED"] as const satisfies Array<SexClass>))
    .optional()
    .catch(undefined),
  animalBreedIds: z.array(z.uuid()).optional().catch(undefined),
  lotId: z.string().optional().catch(undefined),
  lotSourceIds: z.array(z.uuid()).optional().catch(undefined),
  sourceCities: z.array(z.string()).optional().catch(undefined),
  sourceStateCodes: z.array(z.string()).optional().catch(undefined),
  lotDestinationIds: z.array(z.string()).optional().catch(undefined),
  destinationStateCodes: z.array(z.string()).optional().catch(undefined),
  destinationCities: z.array(z.string()).optional().catch(undefined),
  feedyardIds: z.array(z.uuid()).optional().catch(undefined),
  dateOpenedBefore: z.string().date().optional().catch(undefined),
  dateOpenedAfter: z.string().date().optional().catch(undefined),
  dateClosedBefore: z.string().date().optional().catch(undefined),
  dateClosedAfter: z.string().date().optional().catch(undefined),
  weightAverageInMin: z.string().optional().catch(undefined),
  weightAverageInMax: z.string().optional().catch(undefined),
});

export type BenchmarkFilters = z.infer<typeof filterSchema>;

export const Route = createFileRoute("/(authed)/_layout/benchmarks")({
  component: Benchmarks,
  validateSearch: filterSchema,
  errorComponent: (props) => (
    <ErrorComponent title="Benchmarks Error" message="There was a problem loading the benchmarks." {...props} />
  ),
});
